<!-- 发票提取单据 -->
<template>
  <div>
    <div class="fixedRight">
      <el-form :inline="true" @submit.native.prevent>
        <el-row>
          <el-form-item :label="item.fieldShow + ':'" v-for="(item, index) in searchTermList" :key="index"
            v-show="item.isShow == 1">
            <el-input style="width: 200px" v-if="item.fieldType == 'string' && item.isShow" @change="(val) => {
              handleChange(val, item.fieldEntity);
            }
            " :placeholder="'请输入' + item.fieldShow" v-model.trim="item.value" size="mini" clearable>
            </el-input>
            <!-- 开始时间 -->
            <el-date-picker v-else-if="item.fieldEntity == 'start'" size="mini" v-model="item.value"
              format="yyyy 年 MM 月 dd 日" @change="(val) => {
                handleChange(val, item.fieldEntity);
              }
              " value-format="timestamp" type="date" placeholder="选择日期"></el-date-picker>
            <!-- 结束时间 -->
            <el-date-picker v-else-if="item.fieldEntity == 'end'" @change="changeTime" size="mini" v-model="item.value"
              format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date" placeholder="选择日期"></el-date-picker>

            <el-date-picker v-else-if="item.fieldType == 'date' && item.isShow"
              @change="(val) => { handleChange(val, item.fieldEntity); }" size="mini" v-model="item.value"
              format="yyyy 年 MM 月 dd 日" value-format="timestamp" type="date" placeholder="选择日期">
            </el-date-picker>
            <el-input style="width: 200px" v-else-if="item.fieldType == 'number' && item.isShow" @change="(val) => {
              handleChange(val, item.fieldEntity);
            }
            " :placeholder="'请输入' + item.fieldShow" v-model.number="item.value" clearable size="mini">
            </el-input>
            <el-select size="mini" v-else-if="item.fieldType == 'formatter' && item.isShow" @change="(val) => {
              handleChange(val, item.fieldEntity);
            }
            " v-model="item.value" placeholder="请选择">
              <el-option v-for="matItem in JSON.parse(item.formatterContent)" :key="matItem.key" :label="matItem.key"
                :value="matItem.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="mini" @click="searchData">查询</el-button>
          </el-form-item>
        </el-row>
      </el-form>
    </div>
    <el-table ref="moviesTable" height="340" size="mini" @selection-change="mainSelectionChange" style="width: 100%"
      :data="mainData" border>
      <el-table-column type="selection" width="50" :selectable="selectEnable" disabled="true"></el-table-column>
      <template v-for="(item, index) in Columns">
        <!-- 数字 -->
        <el-table-column v-if="item.fieldType == 'formatter' &&
          item.isShow &&
          item.formatterContent
        " align="center" :key="index" min-width="140" :prop="item.fieldEntity" :sortable="item.isSort"
          :label="item.fieldShow" :show-overflow-tooltip="true">
          <!-- 各种状态判断 -->
          <template slot-scope="scope">
            <el-tag size="mini" type="primary">{{
              $common.getIsGsp(item.formatterContent, scope.row[item.fieldEntity])
            }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column v-else-if="item.fieldType == 'string' && item.isShow" align="center" :key="index + 'a'"
          min-width="120" :prop="item.fieldEntity" :sortable="item.isSort" :label="item.fieldShow"
          :show-overflow-tooltip="true">
        </el-table-column>
        <el-table-column v-else-if="item.fieldType == 'date' && item.isShow" align="center" :key="index + 'b'"
          min-width="120" :prop="item.fieldEntity" :sortable="item.isSort" :label="item.fieldShow"
          :show-overflow-tooltip="true">
          <template slot-scope="scope">
            <span>{{ $common.getLocalTime(scope.row[item.fieldEntity]) }}</span>
          </template>
        </el-table-column>
        <el-table-column v-else-if="item.fieldType == 'number' && item.isShow" align="center" :key="index + 'c'"
          min-width="120" :prop="item.fieldEntity" :sortable="item.isSort" :label="item.fieldShow"
          :show-overflow-tooltip="true">
        </el-table-column>
      </template>
      <!-- <el-table-column v-if="!isDetail" fixed="right" label="操作" width="110" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="text" @click.stop="handleSelectClick(scope.row)">确认选择</el-button>
        </template>
      </el-table-column> -->
    </el-table>
    <!-- 分页 -->
    <div style="display: flex;align-items: center;">
      <el-pagination v-if="isPagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="currentPage" :page-sizes="pageSizes" background :page-size="pageSize"
        layout="total, sizes, prev, pager, next" :total="total">
      </el-pagination>
    </div>

    <el-collapse v-model="activeName" accordion>
      <el-collapse-item name="1" :disabled="true">
        <template slot="title">
          <div style="display: flex;align-items: center;justify-content: space-between;width: 100%;">
            <div>
              <el-switch @change="showDetailChange" v-model="showdetail" active-text="展示明细"
                inactive-text="关闭明细"></el-switch>
              <el-button size="mini" @click="sureDetail" style="margin-left: 60px"
                type="primary">确认选择</el-button>
            </div>
            <div v-if="isMoney">
              <span style="color: #000;">合计金额：</span>
              <span style="color: red;">￥{{ money }}</span>
            </div>
          </div>
        </template>
        <!-- 明细表 -->
        <el-table size="mini" @selection-change="handleSelectionChange1" height="200" :data="detailData" border stripe
          highlight-current-row :header-cell-style="getHeaderCellStyleD" style="width: 100%">
          <!-- <el-table-column v-if="isDetail" type="selection" width="50">
          </el-table-column> -->
          <template v-for="(item, index) in ColumnsDetail">
            <!-- 数字 -->
            <el-table-column v-if="item.fieldType == 'formatter' &&
              item.isShow &&
              item.formatterContent
            " align="center" :key="index" min-width="120" :prop="item.fieldEntity" :sortable="item.isSort"
              :label="item.fieldShow" :show-overflow-tooltip="true">
              <!-- 各种状态判断 -->
              <template slot-scope="scope">
                <el-tag size="mini" type="primary">{{
                  $common.getIsGsp(item.formatterContent, scope.row[item.fieldEntity])
                }}</el-tag>
              </template>
            </el-table-column>
            <el-table-column v-else-if="item.fieldType == 'string' && item.isShow" align="center" :key="index + 'd'"
              min-width="120" :prop="item.fieldEntity" :sortable="item.isSort" :label="item.fieldShow"
              :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column v-else-if="item.fieldType == 'date' && item.isShow" align="center" :key="index + 'e'"
              min-width="120" :prop="item.fieldEntity" :sortable="item.isSort" :label="item.fieldShow"
              :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span>{{
                  $common.getLocalTime(scope.row[item.fieldEntity])
                }}</span>
              </template>
            </el-table-column>
            <el-table-column v-else-if="item.fieldType == 'number' && item.isShow" align="center" :key="index + 'f'"
              min-width="120" :prop="item.fieldEntity" :sortable="item.isSort" :label="item.fieldShow"
              :show-overflow-tooltip="true">
            </el-table-column>
          </template>
        </el-table>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import NP from 'number-precision'

export default {
  name: "ExtractionPurPaymentApply",
  components: {},
  data() {
    return {
      opmId: "",
      ormId: "",
      activeName: "1",//默认展开
      showdetail: true,
      detailData: [],
      currentPage: 1,
      pageSizes: [10, 25, 50, 100],
      pageSize: 10,
      total: 0,
      mainData: [],
      selectedDataIndexList: [],
      isPagination: "",
      searchTermList: [], //检索条件
      Columns: [],
      queryMap: {},
      ColumnsDetail: [],
      isDetail: false,
      multipleSelection: [], //数组内层
      returnObj: {//外层对象数据
        mainData: [],
        detailData: []
      },
      money: 0,
    };
  },

  props: {
    invoiceExtractData: {
      type: Object,
      require: true
    },
    id: {
      type: [Number, String],
      require: true,
    },
    extractParamsData: {
      type: Object,
      require: false,
    },
    parentData: {//选中的数据
      type: Object,
      require: false
    },
    isOutCoId: {//选中的数据
      type: Boolean,
      default: false
    },
    isMoney: {//是否显示合计金额
      type: Boolean,
      default: false
    },
    isMoneyType: {//对应的计算合计金额的字段
      type: [Number, String],
      default: false
    },
  },
  watch: {
    selectedDataIndexList() {
      this.selectedDataIndexList.length > 0 && this.getTableDetailList()
      if (this.selectedDataIndexList.length == 0) {
        this.detailData = []
      }
    },
  },
  computed: {},
  mounted() { },
  created() {
    // 处理组件需要的数据
    this.ormId = JSON.parse(sessionStorage.getItem("loginInfo")).ormId;
    this.opmId = JSON.parse(sessionStorage.getItem("userInfo")).opmId;
    this.$dbCache.Record_Get(this.id).then(async (val) => {
      let exPlan = val
      if (!exPlan) {
        exPlan = await this.extractQuery();
      }
      console.log(exPlan, "提取数据", this.id);
      let {
        pageCount, //分页条目数
        isPagination, //是否分页
        conditionList, //检索信息
        tableMainList, //主表表头信息
        tableDetailList, //明细表头信息
        width, //宽度
        isDetail, // 是否可选择明细
        extractName, //标题
        repetId,
      } = exPlan;
      this.repetId = repetId;
      if (this.isOutCoId == true) {
        conditionList.forEach((item) => {
          if (item.fieldEntity == 'coId') {
            item.fieldEntity = 'outcoId'
          }
        })
      }
      conditionList.forEach((item) => {
        if (item.fieldEntity == 'start') {
          item.value = new Date(new Date().toLocaleDateString()).getTime() -
            7 * 24 * 3600 * 1000
          this.searchData.start = item.value
          console.log(item.value)
        } else if (item.fieldEntity == 'end') {
          item.value = new Date(new Date().toLocaleDateString()).getTime() +
            24 * 60 * 60 * 1000 - 1
          this.searchData.end = item.value
        } else if (item.fieldEntity == 'wobkemId') {
          item.value = this.wobkemId
          this.searchData.wobkemId = item.value
        } else if (item.fieldEntity == 'psbkmId') {
          item.value = this.psbkmId
          this.searchData.psbkmId = item.value
        } else {
          item.value = "";
        }
        for (let key in this.extractParamsData) {
          if (item.fieldEntity == key) {
            item.value = this.extractParamsData[key];
          }
        }
      });

      for (let key in this.extractParamsData) {
        if (this.extractParamsData[key] == undefined) {
          this.extractParamsData[key] = ''
        }
      }
      tableMainList.forEach((item) => {
        item.isShow == 1 ? (item.isShow = true) : (item.isShow = false);
        item.isSort == 1 ? (item.isSort = true) : (item.isSort = false);
      });
      tableDetailList.forEach((item) => {
        item.isShow == 1 ? (item.isShow = true) : (item.isShow = false);
        item.isSort == 1 ? (item.isSort = true) : (item.isSort = false);
      });
      this.$emit("getWidth", width);
      this.$emit("sendTitle", extractName);
      this.isDetail = isDetail == 1 ? true : false
      if (this.isDetail) {
        this.showdetail = true;
        this.activeName = "1";
      } else {
        this.showdetail = false;
        this.activeName = "0";
      }
      this.Columns = tableMainList;
      console.log(tableMainList, tableDetailList);
      this.ColumnsDetail = tableDetailList;
      this.searchTermList = conditionList;
      this.isPagination = isPagination == 0 ? false : true; //是否分页
      // 根据返回数据处理一些页面逻辑
      if (this.isPagination == true) {
        this.pageSizes = pageCount.split(",").map(item => Number(item))
        this.pageSize = parseInt(this.pageSizes[0]);
        // 添加请求参数
        this.searchTermList.forEach((item) => {
          if (item.fieldType == 'date') {
            this.queryMap[item.fieldEntity] = item.value
            return
          }
          this.queryMap[item.fieldEntity] = ''
        });
        // 需要分页
        this.queryMap.extractId = this.id;
        // this.queryMap.smId = this.extractParamsData.smId;
        this.queryMap.ormId = this.ormId;
        this.queryMap.wobkemId = this.wobkemId
        this.queryMap.psbkmId = this.psbkmId
        this.queryMap.page = this.currentPage;
        this.queryMap.rows = this.pageSize;
      } else {
        this.searchTermList.forEach((item) => {
          if (item.fieldType == 'date') {
            this.queryMap[item.fieldEntity] = item.value
            return
          }
          this.queryMap[item.fieldEntity] = ''
        });
        this.queryMap.extractId = this.id;
        // this.queryMap.smId = this.extractParamsData.smId;
        this.queryMap.ormId = this.ormId;
        this.queryMap.wobkemId = this.wobkemId
        this.queryMap.psbkmId = this.psbkmId
      }
      console.log(this.queryMap, this.extractParamsData);
      for (let qkey in this.queryMap) {
        for (let key in this.extractParamsData) {
          if (qkey == key) {
            this.queryMap[qkey] = this.extractParamsData[key];
          }
        }
      }

      this.getTableMainList(this.queryMap);
    });
  },
  methods: {
    async extractQuery() {
      const res = await this.$http.extractQueryExtractLinkById({ ids: [this.id] });
      if (res.status == 200) {
        return res.result;
      } else {
        this.$message.error(res.message);
        return {};
      }
    },
    // 勾选明细
    handleSelectionChange1(val) {
      this.multipleSelection = val;
      if (val.length) {
        this.detailsub = false;
      } else {
        this.detailsub = true;
      }
    },
    // 表格方法
    rowClassName({
      row,
      rowIndex
    }) {
      let rowName = "",
        findRow = this.selectedRow.find((c) => c.rowIndex === row.rowIndex);
      if (findRow) {
        rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
      }
      return rowName; //也可以再加上其他类名 如果有需求的话
    },
    rowStyle({
      row,
      rowIndex
    }) {
      Object.defineProperty(row, "rowIndex", {
        // 给每行添加不可枚举属性rowIndex来标识当前行
        value: rowIndex,
        writable: true,
        enumerable: false,
      });
      let rowBackground = {}
      if (row.bgColor && row.bgColor != '') rowBackground.backgroundColor = row.bgColor
      return rowBackground
    },
    searchData() {
      console.log(this.queryMap);
      this.currentPage = 1;
      this.queryMap.page = 1;
      this.getTableMainList(this.queryMap);
    },
    clickEvent(row, column, event, params) {
      let refsElTable = this.$refs.moviesTable; // 获取表格对象
      this.selectedIndex = row.rowIndex;
      let findRow = {};
      findRow = this.selectedRow.find((c) => c.rowIndex == row.rowIndex); //找出当前选中行
      //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
      if (findRow && this.selectedRow.length === 1) {
        refsElTable.toggleRowSelection(row, false);
        return;
      }
      refsElTable.clearSelection();
      refsElTable.toggleRowSelection(row);
      this.handleClick(row);
    },
    //明细隐藏
    showDetailChange(e) {
      e == true ? (this.activeName = "1") : (this.activeName = "0");
    },
    // 切换显示条数
    setDataPageSize(val) {
      this.getRequestData.page = 1
      this.getRequestData.rows = val
      this.getTableMainList()
    },
    changeTime(val) {
      if (val) {
        var time = val + 24 * 60 * 60 * 1000 - 1;
        this.queryMap.end = time
        // this.queryData.end = time;
      }
    },
    //默认勾选禁用状态
    selectEnable(row, rowIndex) {
      if (this.parentData && this.parentData.list.length > 0) {
        var flag = false
        this.parentData.list.forEach(item => {
          if (row[this.parentData.type] == item[this.parentData.type]) {
            flag = true
          }
        })
        if (flag) {
          return false
        }
      }
      return true
    },
    //主单选择
    mainSelectionChange(val) {
      this.returnObj.mainData = JSON.parse(JSON.stringify(val))
      this.selectedDataIndexList = []
      val.forEach(v => {
        if (this.id == '553755277398017' || this.id == '553755277398018') {
          this.selectedDataIndexList.push(v.dasmId)
        } else {
          this.selectedDataIndexList.push(v.dapmId)
        }
      })
      if (this.parentData && this.parentData.list.length > 0) {
        this.mainData.forEach(item => {
          this.parentData.list.forEach(item1 => {
            if (item[this.parentData.type] == item1[this.parentData.type]) {
              this.$refs.moviesTable.toggleRowSelection(item, true);
            }
          })
        })
        if (this.returnObj.mainData.length > 0) {
          this.parentData.list.forEach(item1 => {
            this.returnObj.mainData.forEach((item, index) => {
              if (item[this.parentData.type] == item1[this.parentData.type]) {
                this.returnObj.mainData.splice(index, 1)
              }
            })
          })
          this.returnObj.mainData = this.returnObj.mainData.concat(this.parentData.list)
        } else {
          this.returnObj.mainData = this.parentData.list
        }
      }
      if (this.isMoney) {
        this.money = 0
        this.returnObj.mainData.forEach(item => {
          var arr = this.parentData.list.filter(val => val.dasmId == item.dasmId)
          if (arr.length == 0) {
            this.money = this.$common.getDecimalInfo(3, NP.plus(item[this.isMoneyType], this.money))
          }
        })
      }
    },
    dblclick(row) {
      var flag = false
      this.returnObj.mainData.forEach((item, index) => {
        if (item.businessId == row.businessId && !flag) {
          console.log(item.businessId, row.businessId);
          flag = true
          this.$refs.moviesTable.toggleRowSelection(row, false)
          this.returnObj.mainData.splice(index, 1)
        }
      })
      if (!flag) {
        this.$refs.moviesTable.toggleRowSelection(row, true)
        this.returnObj.mainData.push(row)
      }
    },
    //确认选择
    sureDetail() {
      this.returnObj.detailData = JSON.parse(JSON.stringify(this.detailData))
      this.returnObj.mainData.sort(function (a, b) {
        return b.createTime - a.createTime
      })
      this.returnObj.detailData.sort(function (a, b) {
        return b.createTime - a.createTime
      })
      this.$emit("invoiceExtractMethods", this.returnObj);
    },
    handleChange(value, name) {
      console.log(value, name);
      // value默认参，name当前所需的name
      this.queryMap[name] = value;
    },
    // 获取主表格
    async getTableMainList() {
      console.log(this.queryMap);
      const obj = { ...this.queryMap }
      if (this.isOutCoId) {
        obj.coId = this.queryMap.outcoId;
        delete obj.outcoId;
      }
      this.money = 0
      let res = await this.$http.queryExtractPlanMainVo(obj)
      if (res && res.status == 200) {
        this.total = res.total;
        this.mainData = res.rows; //默认第一条
        if (this.parentData && this.parentData.list.length > 0) {
          this.$nextTick(() => {
            // 默认勾选数据
            setTimeout(() => {
              this.mainData.forEach(item => {
                this.parentData.list.forEach(item1 => {
                  if (item[this.parentData.type] == item1[this.parentData.type]) {
                    this.$refs.moviesTable.toggleRowSelection(item, true);
                  }
                })
              })
              this.returnObj.mainData = this.parentData.list
            }, 100)
            if (this.isMoney) {
              this.parentData.list.forEach(item => {
                this.money = this.$common.getDecimalInfo(3, NP.plus(item[this.isMoneyType], this.money))
              })
            }
          })
        }
      } else {
        this.$message({
          message: res.message,
          type: 'error'
        });
        this.$emit("invoiceExtractMethods", '')
        return false
      }
    },
    // 获取明细表格
    async getTableDetailList() {
      this.detailData = []
      //   this.selectedDataIndexList.forEach(async item => {
      //     let res = await this.$http.queryExtractPlanDetailVo({
      //       id: item,
      //       extractId: this.id,
      //     })
      //     if (res && res.status == 200) this.detailData.push(...res.rows)
      //     this.isDetail = this.detailData.length > 0 ? true : false
      //   })
      let res = await this.$http.queryExtractPlanDetailVo({
        id: this.selectedDataIndexList[this.selectedDataIndexList.length - 1],
        extractId: this.id,
      })
      if (res && res.status == 200) this.detailData = res.rows
      this.isDetail = this.detailData.length > 0 ? true : false

    },
    //分页
    handleSizeChange(val) {
      this.pageSize = val;
      this.invoiceExtractData.rows = val;
      this.queryMap.page = 1
      this.queryMap.rows = val
      this.getTableMainList();
    },
    // 分页
    handleCurrentChange(val) {
      this.currentPage = val;
      this.invoiceExtractData.page = val;
      this.queryMap.page = val
      this.getTableMainList();
    },
    //   -----------------------------------------------------
    getHeaderCellStyle() {
      return "background: skybule; borderBottom: solid 1px #5a5e66;color: #3e5569";
    },
    getHeaderCellStyleD() {
      return "background: skybule;color: #3e5569";
    },

  },
};
</script>

<style scoped>
.el-pagination {
  padding: 20px 0px 5px;
}
</style>
